function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImportantMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 219.37 219.34"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M219.36 118.68V53.63c0-25.9-13.25-39.15-24.36-45.71A60.6 60.6 0 0 0 170.9 0H56.1C54.51 0 31.21 0 15 15.91 5.06 25.69 0 39.19 0 56v51.88c-.09 2.32-.67 27.47 16.33 45.32 10.46 11 25.17 16.76 43.76 17.16l48 48.94 50-47.19a4.91 4.91 0 0 0 1.24-1.85l7.22.13c16.62 0 29.73-4.89 39-14.52 14.16-14.71 13.87-35.23 13.81-37.19Zm-21 30.46c-7.3 7.57-18 11.41-31.75 11.41-1.28 0-40.75-.72-61.58-1.09a4.94 4.94 0 1 0-.17 9.87l41.09.73-37.55 35.46-44.12-45h-2.07c-16.74 0-29.74-4.73-38.66-14.05C9 131.28 9.88 108.49 9.89 108.27V56c0-14.07 4-25.19 12-33C35 10.07 54.83 9.87 55.93 9.87h114.42A50.85 50.85 0 0 1 190 16.43c13 7.63 19.51 20.15 19.51 37.2V119c-.01.15.49 18.06-11.12 30.14Z",
  style: {
    fill: "#ad112b"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.69 99.53a4.94 4.94 0 0 0 4.94-4.93V54.12a4.94 4.94 0 0 0-9.87 0V94.6a4.93 4.93 0 0 0 4.93 4.93Z",
  style: {
    fill: "#ad112b"
  }
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110.57,
  cy: 115.7,
  r: 5.8,
  style: {
    fill: "#ad112b"
  }
}));
export default SvgImportantMessage;